import React from 'react'
import classes from './Buttons.module.css'
import { AccessibilityHidden, AccessibilityButton } from '@skillz/accessibility';

const PrimaryBtn = ({ onClick, color, background, borderColor, dropClass, isBtn = true, xsmall, disabled, children, accessibilityDescription }) => {

    const handleclick = (e) => {
        e.stopPropagation()
        if (disabled) return;
        onClick && onClick()
    }

    return (
        <AccessibilityButton
            accessibilityDescription={accessibilityDescription}
            className={`${classes.Btn} ${classes.PrimaryBtn} ${disabled ? classes.Disabled : ""} ${dropClass}${xsmall ? ` ${classes.Xsmall}` : ""}`}
            onClick={isBtn ? handleclick : ''}
            style={{ color: color, background: disabled ? '#A3A3A3' : background, borderColor: borderColor, cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
            {children}
        </AccessibilityButton>
    )
}


export default PrimaryBtn;